















import {
    Component,
    Vue
} from 'vue-property-decorator';
import BannerBlog from '@/components/banner-blog/index.vue';
import Prism from 'prismjs';
import 'prismjs/themes/prism.css';
@Component({
    name: 'BlogDetail',
    components: {
        BannerBlog
    }
})
export default class BlogDetail extends Vue {
    private title: string = '';
    private tip: string = '';
    private banner: string = '';
    private id: string = '';
    private blogDetail: string = '';
    private blogList: any = [];
    private created() {
        this.id = this.$route.params.id;
        this.getBlogData();
        this.getBlogDetail();
    }
    private getBlogDetail(): void {
        this.$axios.get(`/data/blogs/${this.id}.html`).then((res: any) => {
            this.blogDetail = res.data;
            this.showHighCode();
        }).catch(() => {
            this.blogDetail = '<h3>文章加载失败~~</h3>';
        });
    }
    private getBlogData(): void {
        this.$axios.get('/data/blog.json').then((res: any) => {
            const dataIndex = res.data.findIndex((item: any) => {
                return item.id === this.id;
            });
            this.blogList = res.data.slice(dataIndex + 1, dataIndex + 4);
            this.blogList = this.blogList.concat(res.data.slice(0, Math.max(3 - this.blogList.length, 0)));

            const data = res.data[dataIndex];
            this.title = data.title;
            this.tip = data.tip;
            this.banner = data.banner;
        });
    }
    private showHighCode(): void {
        this.$nextTick(() => {
            Prism.highlightAll();
            setTimeout(() => {
                this.goAnchor();
            }, 0);
        });
    }
    private goAnchor() {
        const selector: any = this.$route.query.id;
        if (selector) {
            const  anchor: any = document.getElementById(selector);
            document.documentElement.scrollTop = anchor.offsetTop;
        }
    }
}
